<template>
  <div class="bg" @scroll="scrollfn" ref="bigbox">
    <div class="main" ref="main">
      <div class="img-box" v-for="(item, i) in imgList" :key="i">
        <img :src="item.img" class="img" v-if="item.show" />
        <a href="tel:19128618254" class="call" v-if="showCall && i == imgList.length - 1"></a>
        <a href="tel:89448086" class="call2" v-if="showCall && i == imgList.length - 1"></a>
      </div>
      <div class="bottom">
        <span>© 重本紫腾教育科技（广州）有限公司 版权所有。</span>
        <a class="beian" href="https://beian.miit.gov.cn">粤ICP备2021074338号</a>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
const wx = require("weixin-js-sdk");
export default {
  mounted() {
    document.title = "重本·紫腾     艺体生文化课";
    this.setShare();
  },
  data() {
    return {
      imgList: [
        {
          img: require("@/assets/img/art/M-1.png"),
          show: true,
        },
        {
          img: require("@/assets/img/art/M-2.png"),
          show: true,
        },
        {
          img: require("@/assets/img/art/M-3.png"),
          show: true,
        },
        {
          img: require("@/assets/img/art/M-4.png"),
          show: false,
        },
        {
          img: require("@/assets/img/art/M-5.png"),
          show: false,
        },
        {
          img: require("@/assets/img/art/M-6.png"),
          show: false,
        // },
        // {
        //   img: require("@/assets/img/art/7.png"),
        //   show: false,
        // },
        // {
        //   img: require("@/assets/img/art/8.png"),
        //   show: false,
        // },
        // {
        //   img: require("@/assets/img/art/9.png"),
        //   show: false,
          // },
          // {
          //   img: require("@/assets/img/art/10.png"),
          //   show: false,
        },
      ],
      swiperOption: {
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
        // 设置轮播
        // effect: 'flip',
        effect: "slide",
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "horizontal",
        // 分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
      },
      clickBox: [
        {
          name: "家校紧密",
          imgLink: require("../assets/img/tx/1.jpg"),
        },
        {
          name: "德育管理",
          imgLink: require("../assets/img/tx/5.jpg"),
        },
        {
          name: "封闭式管理",
          imgLink: require("../assets/img/tx/6.jpg"),
        },
      ],
      selectData: {
        name: "家校紧密",
        imgLink: require("../assets/img/tx/1.jpg"),
      },
      isShow: false,
      showCall: false,
      showNum: 2,
    };
  },
  methods: {
    scrollfn() {
      if (
        this.$refs.main.offsetHeight -
        (this.$refs.bigbox.scrollTop + this.$refs.bigbox.offsetHeight) <
        50
      ) {
        this.showNum++;
        if (this.showNum > this.imgList.length - 1) return;
        console.log(this.showNum);
        this.imgList[this.showNum].show = true;
        if (this.showNum == this.imgList.length - 1) {
          this.showCall = true;
        }
      }
    },
    go(val, i) {
      // let a = document.createElement('a')
      // a.href = `#No${i}`
      // a.click()
      document.querySelector(`#No${i}`).scrollIntoView(true);
    },
    id(id) {
      return "No" + id;
    },
    goActivity(item) {
      if (item.link) {
        window.location.href = item.link;
      }
    },
    setShare() {
      let url = "https://www.zhongbenziteng.com/yt-m/index.html"; // 显示页面地址
      api.wechat.jsSdkConfig2({ params: { url } }).then(function (res) {
        // 微信小程序接口起调配置
        console.log(res.data.data);
        console.log(wx);
        wx.config({
          debug: false,
          appId: res.data.data.appId,
          timestamp: res.data.data.timestamp,
          nonceStr: res.data.data.noncestr,
          signature: res.data.data.signature,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "getLocation",
            "openLocation",
          ],
        });
        wx.ready(function () {
          console.log("????");
          wx.checkJsApi({
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              console.log(res);
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            },
          });
          wx.onMenuShareTimeline({
            title: "重本·紫腾 艺体生文化课", // 分享标题
            desc: "艺考 更易考", // 分享描述
            link: "https://www.zhongbenziteng.com/yt-m/index.html#/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              "https://boss-prd.oss-cn-shenzhen.aliyuncs.com/otherFile/web/202106/f505dc06-a43f-4799-8bb1-c77c517d78cc.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              alert("分享成功");
            },
          });
          wx.onMenuShareAppMessage({
            title: "重本·紫腾 艺体生文化课", // 分享标题
            desc: "艺考 更易考", // 分享描述
            link: "https://www.zhongbenziteng.com/yt-m/index.html#/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              "https://boss-prd.oss-cn-shenzhen.aliyuncs.com/otherFile/web/202106/f505dc06-a43f-4799-8bb1-c77c517d78cc.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              alert("分享成功");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: scroll;
}

.img {
  width: 100%;
}

.none {
  /* display: none; */
  position: absolute;
  left: 0;
  width: 100%;
  height: 0;
}

.absoluteBox {
  position: absolute;
  top: 2625px;
  left: 50%;
  width: 100%;
  /* height: 78px; */
  padding: 0 23px;
  transform: translateX(-50%);
  box-sizing: border-box;
}

.fixedBox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 78px;
  background: url("../assets/img/fixed.png") no-repeat;
  background-size: 100%;
}

.fake-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 70px;
  /* padding: 0 25px; */
  box-sizing: border-box;
}

.fake {
  width: 100px;
  height: 45px;
}

.box {
  position: absolute;
  top: 5145px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 326px;
  height: 214px;
  border-radius: 5px;
  overflow: hidden;
}

.clickbox {
  position: absolute;
  top: 2976px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  display: flex;
  width: 326px;
  height: 214px;
  border-radius: 5px;
  overflow: hidden;
}

.option {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 52px;
  font-size: 12px;
  color: #666666;
  background: #e2e2e2;
}

.selected {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 53px;
  font-size: 12px;
  color: #fff;
  background: #db4527;
}

.right {
  width: 245px;
  height: 160px;
}

.right>img {
  width: 100%;
  object-fit: contain;
}

/* 活动 */
.activity {
  position: absolute;
  top: 4314px;
  left: 50%;
  width: 345px;
  height: 447px;
  padding: 0 15px;
  box-sizing: border-box;
  transform: translateX(-50%);
}

.activity-big {
  display: flex;
  width: 100%;
  height: 90px;
  margin-bottom: 10px;
  border-radius: 15px;
  overflow: hidden;
}

.activity-big:nth-child(4) {
  margin-bottom: 15px;
}

.activity-small {
  width: 50%;
  height: 100%;
}

.oneOnOne {
  width: 315px;
  height: 42px;
  border-radius: 21px;
}

.swiper {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.box2 {
  position: absolute;
  top: 5456.25px;
  left: 50%;
  transform: translateX(-50%);
  width: 326px;
  height: 180px;
  border-radius: 5px;
  overflow: hidden;
}

.swiper2 {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  overflow: hidden;
}

.img {
  width: 100%;
}

.box3 {
  position: absolute;
  top: 4923px;
  left: 50%;
  transform: translateX(-50%);
  width: 326px;
  height: 214px;
  border-radius: 20px;
  overflow: hidden;
}

.swiper3 {
  width: 100%;
  height: 100%;
}

.swiper-pagination {
  position: absolute;
  bottom: 0;
  right: 0;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 55px;
  padding: 0 15px;
  background: url("../assets/img/foot-btn.png") no-repeat;
  background-size: 100%;
  box-sizing: border-box;
}

.save {
  width: 80px;
  height: 37px;
  border-radius: 19px;
}

.rightNow {
  width: 171px;
  height: 37px;
  border-radius: 19px;
}

.tips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 109;
}

.call {
  position: absolute;
  bottom: 55px;
  left: 26px;
  display: block;
  width: 248px;
  height: 32.5px;
  background-color: rgba(0, 0, 0, 0.3);
}

.call2 {
  position: absolute;
  bottom: 85px;
  left: 26px;
  display: block;
  width: 248px;
  height: 32.5px;
  background-color: rgba(47, 12, 187, 0.3);
}

.bottom {
  width: 100%;
  /* margin-bottom: 55px; */
  font-size: 12px;
  color: #999;
  text-align: center;
  background-color: #4a4a4a;
}

.beian {
  color: #999;
  text-decoration: none;
}

.beian:hover {
  text-decoration: underline;
}

.img-box {
  position: relative;
}
</style>
<style>
.my-bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  background-color: #b2aba1;
  border-radius: 50%;
  opacity: 0.4;
}

.my-bullet-active {
  background: #fff;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/art.vue